import * as React from 'react';
import { Picker } from '@shared-ui/global-navigation-picker';
import { SharedUIHeaderLineOfBusiness } from '../../../common/header/header';
export var SharedUIPickerWrapper = function (props) {
  var pickerTriggerPlacementType = props.pickerTriggerPlacementType;
  return React.createElement(SharedUIHeaderLineOfBusiness.Consumer, null, function (lineOfBusiness) {
    return React.createElement(Picker, {
      lineOfBusiness: lineOfBusiness,
      pickerTriggerPlacementType: pickerTriggerPlacementType
    });
  });
};